import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMedicos } from './hooks/useMedicos';

import { Error, IconButton, LimiteFilter, Loader, PaginationButton } from '../../components';
import { MedicosSearch } from './components/MedicosSearch/MedicosSearch';

import { colors } from '../../types/types';

import styles from './Medicos.module.css';

const getInitialsMedico = (nombre = '') => {

    const words = nombre.trim().split(/\s+/).filter(Boolean);

    if (words.length === 0) return '';

    if (words.length === 1) {
        return words[0].charAt(0).toUpperCase();
    }

    return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();

};

export const Medicos = () => {

    const navigate = useNavigate();

    const [searchString, setSearchString] = useState('');
    const [searchLimite, setSearchLimite] = useState('8');
    const [searchPag, setSearchPag] = useState(1);

    const { medicosQuery: { isLoading, isFetching , isError, data: { desde, hasta, medicos, pagina, total, total_paginas } } } = useMedicos({ searchString, searchLimite, searchPag });
  
    const prevPage = () => {
        if (searchPag === 1) {
            return;
        }

        setSearchPag(searchPag - 1);
    };

    const nextPage = () => {
        if (total_paginas <= searchPag) {
            return;
        }

        setSearchPag(searchPag + 1);
    };

    const handleViewMedico = (id) => {
        navigate(`/medico/view/${id}`);
    }
  
    return <div className="row">
        <div className="col">
            <div className={styles.panel + " " + styles.panelNoHeader}>
                {(isLoading)
                    ? <Loader />
                    : <>
                        {(isError)
                            ? <Error />
                            : <>
                                <div className="row">
                                    <div className="col-sm-12 col-md-3">
                                        <div className={styles.header}>Médicos</div>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <MedicosSearch setSearchString={setSearchString} />
                                    </div>
                                    <div className="col-sm-12 col-md-3">
                                        <div className={styles.filterContainer}>
                                            <LimiteFilter
                                                name='Medicos'
                                                onChange={(lim) => setSearchLimite(lim)}
                                                value={searchLimite}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="table-responsive">
                                            <table className="table align-middle">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">Médico</th>
                                                        <th scope="col">Email</th>
                                                        <th scope="col">Celular</th>
                                                        <th scope="col">Verificación email</th>
                                                        <th scope="col">Validado</th>
                                                        <th scope="col">Activo</th>
                                                        <th scope="col"></th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-group-divider">
                                                    {(isFetching)
                                                        ? <tr className='noBorder noHover noPointer'><td colSpan={7}><Loader /></td></tr>
                                                        : medicos.map(medico => <tr key={ medico._id } onClick={() => handleViewMedico(medico._id)}>
                                                            <td>
                                                                <div className={styles.medicoContainer}>
                                                                    {medico.img
                                                                        ? (
                                                                            <img
                                                                                src={medico.img}
                                                                                alt={medico.nombre}
                                                                                className={styles.medicoImg}
                                                                            />
                                                                        )
                                                                        : (
                                                                            <div className={styles.medicoInitials}>
                                                                                {getInitialsMedico(medico.nombre)}
                                                                            </div>
                                                                        )
                                                                    }
                                                                    <span>{medico.nombre}</span>
                                                                </div>
                                                            </td>
                                                            <td>{ medico.email }</td>
                                                            <td>{ medico.celular }</td>
                                                            <td><span className="badge" style={{backgroundColor: (medico.emailVerification) ? colors.SUCCESS : colors.DANGER}}>{ (medico.emailVerification) ? 'Si' : 'No' }</span></td>
                                                            <td><span className="badge" style={{backgroundColor: (medico.validado) ? colors.SUCCESS : colors.DANGER}}>{ (medico.validado) ? 'Si' : 'No' }</span></td>
                                                            <td><span className="badge" style={{backgroundColor: (medico.activo) ? colors.SUCCESS : colors.DANGER}}>{ (medico.activo) ? 'Si' : 'No' }</span></td>
                                                            <td>
                                                                <IconButton
                                                                icon='ChevronRight'
                                                                iconColor='#666666'
                                                                marginTop={false}
                                                                onClick={() => handleViewMedico(medico._id)}
                                                                type='button'
                                                                />
                                                            </td>
                                                        </tr>)
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className='d-flex justify-content-center align-items-center'>
                                            <div>
                                                <PaginationButton
                                                    disabled={!(pagina > 1)}
                                                    onClick={prevPage}
                                                    type='prev'
                                                />
                                            </div>
                                            <div>{ desde } - { hasta } de { total }</div>
                                            <div>
                                                <PaginationButton
                                                    disabled={!(pagina < total_paginas)}
                                                    onClick={nextPage}
                                                    type='next'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </>
                }
            </div>
        </div>
    </div>
}
